// Imports
import { useStateValue } from '../../_global/jsx/store';
import { dangerousHTML } from 'src/lib/utils.js';


// Stateful components

export const ReactQuestionThreeAnswers = () => {

    const [{ globalText, componentsData, userData, controlData } , dispatch] = useStateValue();

    const clickHandler = (index) =>  {
       // event.preventDefault();        
        
        var appNameString = globalText.gaAppName;
        var appLabel = controlData.currentItem.headerText + ' option: ' + globalText['threeBtnLabel_'+index];

        // fix for window.dataLayer undefined in Firefox
        window.dataLayer = window.dataLayer || [];
        
        window.dataLayer.push({"event": "interaction", "target": appNameString, "action": "option selected", "label": (appLabel)}); 
        
        dispatch({
            type: 'answerSelected',
            value: {userResponse: index}
        });
    }

    const getClassNames = (button_id) =>{
        if(userData.questionResponses[controlData.currentItem.assetID] ===  button_id){
            return 'br-app-btn selected';
        }
        return 'br-app-btn';
    }
  
    const getQuestionResponse = () => {
        let response = userData.questionResponses[controlData.currentItem.assetID];

        if(response!== null){
            return (
                //<div dangerouslySetInnerHTML={dangerousHTML(controlData.currentItem['q_response_'+response])}></div>
                <div>
                    <p>{controlData.currentItem['q_response_'+response]}</p>
                </div>
            )
        }
    
        return null;
    }

    /*
    q_response_0: 'Q response Text 0',
                            q_response_1: 'Q response Text 1',
                            q_response_2: 'Q response Text 2',

                            */

    // Functions

    // returns an array of react components of List Items for the Progress Component
    

    /*


    
            <div class="br-app-main-content__contents__question">
                <div class="br-app-main-content__input-group">
                    <button class="br-app-btn">Yes</button>
                    <button class="br-app-btn selected">No</button>
                    <button class="br-app-btn">Unsure</button>
                </div>
                <h4>Considerations</h4>
                <p>Your risk environment is always changing, which is why you must be proactive in protecting your company and its
                    assets.
                    By understanding how changes in the economy may impact on your business you can be more agile and responsive.</p>
            </div>

            */

    
    return (
        <div>
           
            <div className="br-app-main-content__contents__question">
                <div className="br-app-main-content__input-group">
                    <button onClick={ () => clickHandler(0) }  className={getClassNames(0)}>{globalText.threeBtnLabel_0}</button>
                    <button onClick={ () => clickHandler(1) }  className={getClassNames(1)}>{globalText.threeBtnLabel_1}</button>
                    <button onClick={ () => clickHandler(2) }  className={getClassNames(2)}>{globalText.threeBtnLabel_2}</button>
                </div>
                {getQuestionResponse()}
            </div>

            
        </div>
    );    
};
